module.exports = __webpack_public_path__ + "static/media/lionel.22fd96a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lionel.jpg
// module id = 380
// module chunks = 16